<template>
  <footer>
    <div
      class="flex-wrap"
      style="
        margin: 32px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      "
    >
      <p style="font-weight: 500; font-size: 16px; color: #80848a; margin: 0">
        Exibindo {{ somarOffset("isRegistrationSum") }}-{{
          somarOffset() > count ? count : somarOffset()
        }}
        de {{ count }}
      </p>
      <div
        class="d-flex justify-content-end align-items-center"
        style="width: 179px; max-width: 179px; cursor: pointer"
      >
        <button
          class="border-0"
          type="button"
          style="background-color: transparent; outline: none"
          :disabled="isDisabledCaseOne"
          @click="$emit('firstPage')"
          title="Primeira"
        >
          <img
            v-if="!isDisabledCaseOne"
            :src="
              require(`@/assets/images/svg/ícone-seta-esquerda-primeiro-azul.svg`)
            "
            alt=""
          />
          <img
            v-else
            :src="
              require(`@/assets/images/svg/ícone-seta-esquerda-primeiro-cinza.svg`)
            "
            alt=""
          />
        </button>

        <button
          class="border-0"
          type="button"
          style="background-color: transparent; outline: none"
          :disabled="isDisabledCaseOne"
          @click="$emit('previousPage')"
          title="Anterior"
        >
          <img
            v-if="!isDisabledCaseOne"
            :src="require(`@/assets/images/svg/ícone-seta-esquerda-azul.svg`)"
            alt=""
          />
          <img
            v-else
            :src="require(`@/assets/images/svg/ícone-seta-esquerda-cinza.svg`)"
            alt=""
          />
        </button>
        <button
          class="border-0"
          type="button"
          style="background-color: transparent; outline: none"
          :disabled="isDisabledCaseTwo"
          @click="$emit('nextPage')"
          title="Próximo"
        >
          <img
            v-if="!isDisabledCaseTwo"
            width="24"
            :src="require(`@/assets/images/svg/ícone-seta-direita-azul.svg`)"
            alt=""
          />
          <img
            v-else
            width="24"
            :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
            alt=""
          />
        </button>
        <button
          class="border-0"
          type="button"
          style="background-color: transparent; outline: none"
          :disabled="isDisabledCaseTwo"
          @click="$emit('lastPage')"
          title="Último"
        >
          <img
            v-if="!isDisabledCaseTwo"
            :src="
              require(`@/assets/images/svg/ícone-seta-direita-ultimo-azul.svg`)
            "
            alt=""
          />
          <img
            v-else
            :src="
              require(`@/assets/images/svg/ícone-seta-direita-ultimo-cinza.svg`)
            "
            alt=""
          />
        </button>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    offset: Number,
    limit: { type: Number, default: 5 },
    count: Number,
  },
  computed: {
    isDisabledCaseOne() {
      if (this.offset > 0) return false;
      else return true;
    },
    isDisabledCaseTwo() {
      if (this.count > this.somarOffset()) return false;
      else return true;
    },
  },
  methods: {
    subtraiOffset() {
      return this.offset - this.limit;
    },
    somarOffset(action) {
      if (action == "isRegistrationSum") {
        return this.offset + 1;
      } else {
        return this.offset + this.limit;
      }
    },
  },
};
</script>
